import * as React from 'react';
import { Grid, GridColumn as Column, GridColumnProps, GridProps, GridRowProps, GridRowClickEvent, GridCellProps, GridKeyDownEvent, GridFilterChangeEvent } from "@progress/kendo-react-grid";
import { ISystemGrid } from 'library/types/ISystemGrid';
import { toDataSourceRequestString, translateDataSourceResultGroups, CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { TextNumericColumnMenuFilter } from '../../library'
import  httpService from './../../service/httpService'
import * as ReactDOM from 'react-dom';
import LoadingPanel from '../common/SystemLoadingPanel';
import { ISystemPanelProps } from '../types/ISystemPanelProps';
import { SystemPanel } from '../dashboard/SystemPanel';
import { TreeList } from '@progress/kendo-react-treelist';
import { MultiColumnComboBox } from '@progress/kendo-react-dropdowns';

const SystemGrid = withState(Grid);
export const SystemMuliColumnDropDown = withState(MultiColumnComboBox);
export const SystemTreeListGrid = withState(TreeList);
export default SystemGrid;

export interface IGrid {
    PatientKeyEncrypted?: string,
    onRowClick?(data: any): void
    onRowDoubleClick?(data: any): void
    refresh?: number
    data?: any
}

export interface IGridColumn {
    label?: string,
    field?: string,
    width?: number,
    format?: string,
    filter?: string,
    customRenderer?(): void
    editor?: string,
    visible?: boolean,
    ColumnMenu?: string,
}

export enum EnumEditor {
    "numeric", "boolean", "date", "text"
}

type ISystemGridProps = ISystemGrid & GridProps & ISystemPanelProps;

const DATA_ITEM_KEY: string = "PrimaryKeyEncrypted";
const SELECTED_FIELD: boolean = true;

export function withState(WrappedGrid: any) {
    return class SystemGrid extends React.PureComponent<ISystemGridProps, any, any>
    {
        static defaultProps = {
            filterable: false,
            pageable: true
        }

        constructor(props: any) {
            super(props);
            this.state = {
                gridData: { data: [], total: 0 },
                dataState: {
                    skip: 0,
                    take: this.props.pageSize || 25,
                    filter: {
                        logic: "and",
                        filters: []
                    } as CompositeFilterDescriptor,
                    group: this.props.group || [],
                    sort: this.props.sort || []
                },
                isLoading: false,
                node: null,
                SelectedRow: true,
                AllowRowClick: true
            }
        }
        componentDidMount() {
            this.ensureDataFetched(false)
            this.setState({ node: ReactDOM.findDOMNode(this) })
        }

        componentDidUpdate(prevProps: any) {
            if (
                prevProps.dataSource != this.props.dataSource ||
                JSON.stringify(prevProps.filters) != JSON.stringify(this.props.filters) ||
                prevProps.refresh != this.props.refresh
            ) {
                this.ensureDataFetched(false)
            }
        }

        ensureDataFetched = (isPageChange: boolean) => {
            const { dataState } = this.state
            let updatedFilters = {}
            if (isPageChange && dataState.filter && dataState.filter.filters && dataState.filter.filters.length > 0) {
                updatedFilters = {
                    ...dataState.filter
                }
            } else {
                updatedFilters = this.props.filter ? this.props.filter : {
                    logic: "and",
                    filters: this.props.filters ? [...this.props.filters] : []
                }
            }
            let updatedState = {
                dataState: {
                    ...this.state.dataState,
                    skip: this.state.dataState.skip,
                    filter: { ...updatedFilters },
                    group: this.props.group || [],
                    sort: this.props.sort || [],
                }
            }

            this.setState({ ...updatedState }, () => this.fetchData(this.state.dataState));
        }

        pageChange = (event: any) => {
            this.setState({
                dataState: {
                    ...this.state.dataState,
                    skip: event.page.skip,
                    take: event.page.take
                }
            }, () => this.ensureDataFetched(true));
        }

        handleDataStateChange = (changeEvent: any) => {
            this.setState({ dataState: changeEvent.dataState });
            this.fetchData(changeEvent.dataState);
        }

        dataStateChange = (e: any) => {
            this.setState({
                ...this.state,
                dataState: e.dataState
            });
        }

        dataRecieved = (gridData: any) => {
            this.setState({
                ...this.state,
                gridData: gridData //gridData
            });
        }

        fetchData(dataState: any) {
            if (!this.props.dataSource) {

                this.setState({
                    gridData: { data: [], total: 0 },
                    dataState: { skip: 0, take: this.props.pageSize || 10, filter: {} }
                });
                return
            }

            const hasGroups = dataState.group && dataState.group.length;
            const queryStr = `${toDataSourceRequestString(dataState)}`; // Serialize the state.
            this.setState({ isLoading: true });

            httpService.get(`${this.props.dataSource}?${queryStr}`)
                .then((response: any) => {
                    var data = JSON.parse(JSON.stringify(response.data))
                    if (data.Data && data.Data.length > 0) {
                        this.setState({
                            isLoading: false,
                            gridData: {
                                data: hasGroups ? translateDataSourceResultGroups(data.Data) : data.Data,
                                total: response.data.Total
                            },
                            dataState: this.state.dataState
                        });
                    } else {
                        this.setState({
                            isLoading: false,
                            gridData: {
                                data: [],
                                total: 0
                            },
                            dataState: this.state.dataState
                        });
                    }
                    if (this.props.onPageChanged) this.props.onPageChanged(event)

                }).catch((error) => {
                    this.setState({ isLoading: false });
                });
        }

        sortChange = (event: any) => {
            this.setState({
                dataState: { ...this.state.dataState, sort: event.sort }
            }, () => this.ensureDataFetched(true));
        }


        getColumns = () => {
            var columns: any[] = [];

            if (this.props.children) {
                if (Array.isArray(this.props.children))
                    columns = this.props.children.map((item: any, index: number) => this.getColumn(index, item.props));
                else columns = [this.getColumn(1, this.props.children.props)]
            }

            if (this.props.columns)
                columns = [...columns, this.props.columns.map((item, index: number) => this.getColumn(index, item))]
            return columns;
        }

        getColumn = (index: number, props: GridColumnProps) => {
            var menuFilter = TextNumericColumnMenuFilter;
            return <Column key={index} minResizableWidth={100} filterable={true} sortable={true} width="auto" columnMenu={menuFilter} {...props} />
        }

        expandChange = (event: any) => {
            if (!event.dataItem || !event.target.props.expandField) return;
            event.dataItem[event.target.props.expandField] = event.value;

            this.setState({
                dataState: { ...this.state.dataState }
            });
            //, () => this.ensureDataFetched(true));

        }


        rowRender = (

            trElement: React.ReactElement<HTMLTableRowElement>,
            props: GridRowProps
        ) => {

            let selected = true;
            const green = { backgroundColor: "rgb(64,192,173,1)" };
            const White = { backgroundColor: "rgb(255,255,255)" };
            const trProps: any = { className: "orderset-highlightrow" };
            //const trProps: any = { style: selected ? green : White, className: "orderset-highlightrow" };

            if (this.props.rowSelector && this.props.rowSelector(props)) {
                return React.cloneElement(trElement, trProps, trElement.props.children);
            }

            else if (this.props.highlightSelectedRow && props.dataItem[this.props.dataItemKey || "PrimaryKeyEncrypted"] && props.dataItem[this.props.dataItemKey || "PrimaryKeyEncrypted"] == this.state.dataItemKey) {
                return React.cloneElement(trElement, trProps, trElement.props.children);
            }
            return trElement;
        };

        onRowClick = (event: GridRowClickEvent) => {
            event.syntheticEvent.stopPropagation();
            event.nativeEvent.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();

            if (this.props.dataItemKey) {
                this.setState({ ...this.state, dataItemKey: event.dataItem[this.props.dataItemKey] })
            } else if (event.dataItem["PrimaryKeyEncrypted"]) {
                this.setState({ ...this.state, dataItemKey: event.dataItem["PrimaryKeyEncrypted"] })
            }
            this.props.onRowClick && this.props.onRowClick(event);
        }

        cellRender = (defaultRendering: React.ReactElement<HTMLTableCellElement> | null, props: GridCellProps) =>
            defaultRendering &&
            <td
                style={{ whiteSpace: 'pre' }}
                colSpan={1}
                role="gridcell"
                aria-colindex={props.ariaColumnIndex}
                aria-selected={props.isSelected ? "true" : "false"}
                data-grid-col-index={props.columnIndex}
                title={`${defaultRendering.props.children}`}>
                {defaultRendering.props.children} </td >;


        onKeyDown = (event: GridKeyDownEvent): void => {
            if (event.nativeEvent.keyCode == 13) {
                event.syntheticEvent.preventDefault();
                event.syntheticEvent.stopPropagation();
                event.nativeEvent.preventDefault();
                event.nativeEvent.stopPropagation();
                event.nativeEvent.stopImmediatePropagation();
                var item = event.nativeEvent.currentTarget.activeElement;
                var container = item.closest(".k-filter-menu-container");
                var filterbutton = container.getElementsByClassName('k-button k-primary')[0];
                //    filterbutton.click();
            }
        }

        onFilterChange = (event: GridFilterChangeEvent) => {
        }

        render() {
            let GridComponenet = <>
                {/*<Tooltip anchorElement="pointer" position="top">*/}
                <WrappedGrid className="grid-header"
                    {...(this.props as GridProps)}
                    //onFilterChange={this.onFilterChange}
                    sortable={{ allowUnsort: true, mode: 'multiple' }}
                    resizable={false}
                    height={this.props.height || "100%"}
                    width={this.props.width || "100%"}
                    sort={this.state.dataState.sort}
                    onSortChange={this.props.sortChange}
                    filterable={this.props.filterable}
                    groupable={this.props.groupable}
                    expandField="expanded"
                    onExpandChange={(event: any) => this.props.onExpandChange ? this.props.onExpandChange(event) : this.expandChange(event)}
                    onRowClick={(event: any) => !this.state.isLoading && this.onRowClick(event)}
                    onRowDoubleClick={(event: any) => !this.state.isLoading && this.props.onRowDoubleClick && this.props.onRowDoubleClick(event)}
                    pageable={this.props.pageable}
                    filter={this.state.dataState.filter}
                    group={this.state.dataState.group}
                    data={this.state.gridData}
                    skip={this.state.dataState.skip}
                    pageSize={this.state.dataState.take}
                    onDataStateChange={this.handleDataStateChange}
                    onPageChange={this.pageChange}
                    children={this.getColumns()}
                    rowRender={this.rowRender}
                    cellRender={this.cellRender}
                // onKeyDown={this.onKeyDown}
                />
                {/*</Tooltip>*/}
                {this.state.isLoading && this.state.node && <LoadingPanel node={this.state.node} />}
            </>

            return (this.props.showPanel ? <SystemPanel {...this.props}>{GridComponenet}</SystemPanel> : GridComponenet);
        }
    }
}

//resizable = { true}
//reorderable = { true}
